export type TelemetryProps = { [key: string]: any };

type LogEventFn = (name: string, properties?: TelemetryProps) => void;
type BasePropsFactory = () => TelemetryProps;

export class FormlyComponentTelemetry {
  private markers = new Map<string, number>();
  private throttles = new Map<string, number>();

  constructor(
    private readonly logEvent: LogEventFn,
    private readonly getBaseProps: BasePropsFactory = () => ({})
  ) {}

  nowMs(): number {
    if (typeof performance !== 'undefined' && performance.now) {
      return performance.now();
    }
    return Date.now();
  }

  mark(marker: string): void {
    this.markers.set(marker, this.nowMs());
  }

  elapsedMs(marker: string): number | null {
    const start = this.markers.get(marker);
    if (start == null) {
      return null;
    }
    return Math.round(this.nowMs() - start);
  }

  clear(marker: string): void {
    this.markers.delete(marker);
  }

  shouldEmit(key: string, minIntervalMs = 2000): boolean {
    const now = this.nowMs();
    const lastEmit = this.throttles.get(key);
    if (lastEmit != null && now - lastEmit < minIntervalMs) {
      return false;
    }
    this.throttles.set(key, now);
    return true;
  }

  event(name: string, properties: TelemetryProps = {}): void {
    this.logEvent(name, {
      ...this.getBaseProps(),
      ...properties,
    });
  }
}
